import { useQuery } from "@tanstack/react-query";

/**
 * Fetches the inbound BCC address from the `inbound_email` edge function, so
 * the address lives only in the Supabase secret instead of being baked into
 * the frontend bundle at build time.
 *
 * Errors resolve to "" on purpose: in demo/FakeRest mode, when the function
 * is not deployed yet, or when the secret is unset, the Settings card should
 * simply stay hidden.
 */
export function useInboundEmail(): string {
  const { data } = useQuery({
    queryKey: ["inbound_email"],
    queryFn: async () => {
      try {
        // Imported lazily so the Supabase client (which needs VITE_SUPABASE_URL
        // at construction) isn't pulled into this module at load time — that
        // would break unit tests that import components without that env.
        const { supabase } = await import("../providers/supabase/supabase");
        const { data, error } = await supabase.functions.invoke<{
          inboundEmail: string;
        }>("inbound_email");
        if (error) return "";
        return data?.inboundEmail ?? "";
      } catch {
        return "";
      }
    },
    staleTime: Infinity,
    retry: false,
  });
  return data ?? "";
}
